var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsAlt = function SvgSettingsAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#525252",
    fillRule: "evenodd",
    d: "M20.417 4.667a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833m-3.3-1.167a5.25 5.25 0 1 1 0 8.167h-10.7a4.083 4.083 0 1 1 0-8.167zm-1.652 2.334H6.417a1.75 1.75 0 1 0 0 3.5h9.048a5.2 5.2 0 0 1-.298-1.75c0-.614.105-1.203.298-1.75M2.333 20.417a5.25 5.25 0 0 1 8.55-4.084h10.7a4.083 4.083 0 1 1 0 8.167h-10.7a5.25 5.25 0 0 1-8.55-4.083m10.202 1.75h9.048a1.75 1.75 0 1 0 0-3.5h-9.048c.193.547.298 1.136.298 1.75 0 .613-.105 1.202-.298 1.75M7.583 17.5a2.917 2.917 0 1 0 0 5.833 2.917 2.917 0 0 0 0-5.833",
    clipRule: "evenodd"
  })));
};
export default SvgSettingsAlt;